import Axios from "axios";
import { getIdpApiBase } from "./idpBase";

export const searchMembersApi = ({
    authToken,
    deviceId,
    userId,
    merchantId,
    page,
    sortBy,
    sort,
    search,
    searchUsername,
    searchMobileNumber,
    searchAccountNumber,
    statusList
}) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURL + "idp/v1/member/search",
            params: {
                userId: userId,
                merchantId: merchantId,
                memberName: search,
                memberUsername: searchUsername,
                mobileNumber: searchMobileNumber,
                accountNumber: searchAccountNumber,
                statusList: statusList,
                sortBy: sortBy,
                sort: sort,
                page: page,
                nRecords: 10
            },
            data: {},
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const searchNonMembersApi = async ({
    authToken,
    deviceId,
    userId,
    merchantId,
    page,
    size,
    searchName,
    searchAccountNumber
}) => {
    if (authToken != null) {
        return Axios({
            method: "GET",
            url: window.ApiURLNew + "nonmember/search/non-member-cc",
            params: {
                userId: userId,
                merchantId: merchantId,
                name: searchName,
                rmNumber: searchAccountNumber,
                page: page,
                size: size && size > 0 ? size : 10
            },
            data: {},
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const getNonMemberPointTransactionApi = async ({
    authToken,
    deviceId,
    userId,
    merchantId,
    page,
    size,
    searchName,
    searchAccountNumber,
    searchDirection,
    dateFrom,
    dateTo
}) => {
    if (authToken != null) {
        return Axios({
            method: "GET",
            url: window.ApiURLNew + "report/non-member-point-transaction",
            params: {
                memberId: userId,
                merchantId: merchantId,
                memberName: searchName,
                rmNumber: searchAccountNumber,
                direction: searchDirection,
                page: page,
                pageSize: size && size > 0 ? size : 10,
                dateFrom: dateFrom,
                dateTo: dateTo
            },
            data: {},
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const viewMemberApi = ({ authToken, deviceId, id }) => {
    if (authToken != null && id != null) {
        return Axios({
            method: "get",
            url: getIdpApiBase() + "v2/member/" + id,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const changeStatusApi = ({ authToken, deviceId, id, status }) => {
    if (authToken != null && id != null) {
        return Axios({
            method: "put",
            url: getIdpApiBase() + "v2/member/" + id + "/status",
            data: {
                status: status,
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const approvalMemberApi = data => {
    if (data.authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURL + data.api,
            data: {
                userId: data.userId,
                merchantId: data.merchantId,
                memberIdList: data.memberIdList
            },
            headers: {
                "Content-Type": "application/json",
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const deleteMemberApi = ({ authToken, deviceId, dataMembers, id }) => {
    const memberId = id || (dataMembers && dataMembers.memberId);
    if (authToken != null && memberId != null) {
        return Axios({
            method: "delete",
            url: getIdpApiBase() + "v2/member/" + memberId,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId,
            },
        });
    }
};

export const uploadMemberApi = ({ authToken, deviceId, userId, merchantId, members }) => {
    if (authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURLNew + "member/upload",
            data: {
                userId: userId,
                merchantId: merchantId,
                members: members
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const uploadTransactionApi = ({ authToken, deviceId, userId, merchantId, requestList }) => {
    if (authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURL + "promotion/posting/multiple",
            data: {
                userId: userId,
                merchantId: merchantId,
                requestList: requestList
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const uploadTransactionS3Api = ({ authToken, deviceId, userId, merchantId, executeDateString, file }) => {
    if (authToken != null) {
        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("merchantId", merchantId);
        formData.append("executeDateString", executeDateString);
        formData.append("file", file);

        return Axios({
            method: "post",
            url: window.ApiURLNew + "batch-upload/upload-file",
            data: formData,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const uploadOfflineRedemptionS3Api = ({ authToken, deviceId, userId, merchantId, file }) => {
    if (authToken != null) {
        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("merchantId", merchantId);
        formData.append("uploadType", "OFFLINE_REDEMPTION");
        formData.append("file", file);

        return Axios({
            method: "post",
            url: window.ApiURLNew + "batch-upload/upload-file",
            data: formData,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const uploadOfflineRedemptionApi = ({ authToken, deviceId, file }) => {
    if (authToken != null) {
        const formData = new FormData();
        formData.append("file", file);

        return Axios({
            method: "post",
            url: window.ApiURL + "point/point-transaction/deductions/imports",
            data: formData,
            headers: {
                authToken: authToken,
                deviceUniqueId: deviceId || "Portal"
            }
        });
    }
};

export const searchHistoryApi = ({
    authToken,
    deviceId,
    userId,
    merchantId,
    createdBy,
    startDate,
    endDate,
    status,
    page
}) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURLNew + "batch-upload/search-upload-file",
            params: {
                userId: userId,
                merchantId: merchantId,
                createdBy: createdBy,
                startDate: startDate,
                endDate: endDate,
                status: status,
                page: page,
                nRecords: 10
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const downloadHistoryApi = ({ authToken, deviceId, userId, merchantId, fileName }) => {
    if (authToken != null) {
        return Axios({
            method: "get",
            url: window.ApiURLNew + "batch-upload/download",
            params: {
                userId: userId,
                merchantId: merchantId,
                fileName: fileName
            },
            headers: {
                "Content-Type": "application/json",
                authToken: authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const memberDelinquencyApi = data => {
    if (data.authToken != null) {
        let page = data.page < 0 ? 0 : data.page;
        return Axios({
            method: "GET",
            url: window.ApiURLNew + "501/deliquency/getMemberListDelinquency",
            params: {
                userId: data.userId,
                merchantId: data.merchantId,
                memberUsername: data.memberUsername,
                rmNumber: data.rmNumber,
                isDelinquentStatus: data.isDelinquentStatus,
                isNonDelinquentStatus: data.isNonDelinquentStatus,
                page: page,
                nRecords: 10,
                pageSize: 10
            },
            data: {},
            headers: {
                "Content-Type": "application/json",
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const viewMemberDelinquencyApi = data => {
    if (data.authToken != null) {
        return Axios({
            method: "post",
            url: window.ApiURLNew + "501/deliquency/getMemberListDetail",
            data: {
                userId: data.userId,
                merchantId: data.merchantId,
                memberUsername: data.memberUsername
            },
            headers: {
                "Content-Type": "application/json",
                authToken: data.authToken,
                deviceUniqueId: data.deviceId
            }
        });
    }
};

export const getPointDetailApi = async ({ memberId, merchantId, authToken, deviceId }) => {
    if (authToken != null) {
        return Axios({
            method: "GET",
            url: window.ApiURL + "idp/v1/member/search/point-details",
            params: {
                memberId,
                merchantId
            },
            data: {},
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                authToken,
                deviceUniqueId: deviceId
            }
        });
    }
};

export const getSearchMemberApi = ({ searchText = "", authToken, deviceId, page = 0, pageSize = 10 }) => {
    const params = {
        statuses: -1,
        page: page || 0,
        pageSize: pageSize || 10,
        sorts: "username:desc"
    };

    if (searchText && searchText.trim()) {
        params.fullname = searchText.trim();
    } else {
        params.username = "";
        params.mobileNumber = "";
        params.fullname = "";
    }

    return Axios({
        method: "get",
        url: getIdpApiBase() + "v2/member",
        params,
        headers: {
            authToken: authToken,
            deviceUniqueId: deviceId || "Portal"
        }
    });
};
